import { ChevronDown } from "lucide-react";
import { usePage, cmsMediaUrl } from "../lib/cms";

export const Hero = () => {
  const { page } = usePage("aanbod");

  const heroTitle = page?.hero_title || "Aanbod.";
  const heroSubtitle =
    page?.hero_subtitle ||
    "Bekijk onze zorgvuldig geselecteerde collectie exclusieve auto's.";
  const intro = page?.intro_text;
  const fallback =
    "https://images.unsplash.com/photo-1776102669015-21d5f6c0cdf8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzcG9ydHMlMjBjYXIlMjBkYXJrJTIwc2hvd3Jvb218ZW58MHx8fHwxNzc4MDUzNjAyfDA&ixlib=rb-4.1.0&q=85";
  const heroImage = cmsMediaUrl(page?.hero_image) || fallback;

  return (
    <section
      data-testid="aanbod-hero"
      className="relative overflow-hidden border-b border-white/[0.06]"
    >
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt={page?.hero_image?.alt_text || "Showroom Maison Vellore"}
          className="w-full h-full object-cover scale-[1.03]"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-950/85 via-ink-950/65 to-ink-950" />
        <div className="absolute inset-0 noise-overlay" />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10 lg:px-12 pt-24 pb-24 md:pt-32 md:pb-32 lg:pt-40 lg:pb-40">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-8 animate-fade-in">
            <span className="h-px w-10 bg-champagne" />
            <span className="text-[11px] tracking-[0.3em] uppercase text-champagne font-body">
              Huidige Collectie
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-display text-white text-6xl sm:text-7xl md:text-8xl lg:text-[9rem] font-light leading-[0.95] tracking-tight animate-fade-up"
          >
            {heroTitle}
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-8 max-w-xl text-base md:text-lg text-zinc-300 font-body leading-relaxed animate-fade-up"
            style={{ animationDelay: "120ms" }}
          >
            {intro || heroSubtitle}
          </p>

          <div
            className="mt-12 flex items-center gap-6 animate-fade-up"
            style={{ animationDelay: "240ms" }}
          >
            <div className="flex items-baseline gap-2">
              <span className="font-display text-4xl text-champagne">08</span>
              <span className="text-xs uppercase tracking-[0.25em] text-zinc-400 font-body">
                auto&apos;s beschikbaar
              </span>
            </div>
            <span className="h-8 w-px bg-white/10" />
            <div className="flex items-baseline gap-2">
              <span className="font-display text-4xl text-white">04</span>
              <span className="text-xs uppercase tracking-[0.25em] text-zinc-400 font-body">
                nieuw deze maand
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 text-zinc-500 animate-fade-in">
        <span className="text-[10px] uppercase tracking-[0.35em] font-body">
          Scroll
        </span>
        <ChevronDown size={14} className="animate-bounce" />
      </div>
    </section>
  );
};

export default Hero;
